import { connect } from "react-redux";
import NoticeMarquee from "./NoticeMarquee";
import { clearNotice } from "actions/notifications";

const mapStateToProps = state => {
  return {
    message: state.notifications.notice,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearNotice: () => dispatch(clearNotice()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NoticeMarquee);
